import ShuffleOutlinedIcon from '@mui/icons-material/ShuffleOutlined';
import { Link, SxProps } from '@mui/material';
import { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { useMarketplaceNavigation } from 'features/SearchCatalogItems/lib/hooks/useMarketplaceNavigation';

interface FindReplacementLinkProps {
    sx?: SxProps;
    dataTestClass?: string;
    onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
    showIcon?: boolean;
}

export const FindReplacementLink = ({
    sx,
    dataTestClass,
    onClick,
    showIcon = false,
}: FindReplacementLinkProps) => {
    const { t } = useTranslation();
    const { navigateToMarketplace } = useMarketplaceNavigation();

    return (
        <Link
            data-testid="find-replacement-link"
            data-testclass={dataTestClass}
            component="button"
            type="button"
            onClick={(e) => {
                e.stopPropagation();
                if (onClick) {
                    onClick(e);
                    return;
                }
                navigateToMarketplace({ clearSearch: true });
            }}
            variant={showIcon ? 'subtitle2' : 'caption'}
            sx={{
                color: 'primary.main',
                textDecoration: 'none',
                cursor: 'pointer',
                ...(showIcon
                    ? {
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '4px',
                          height: '32px',
                          minHeight: '32px',
                          boxSizing: 'border-box',
                          padding: '0 10px',
                          borderRadius: '4px',
                          fontSize: '1.3rem',
                          fontWeight: 500,
                          lineHeight: '2rem',
                          '&:hover': {
                              backgroundColor: '#E8EEF6',
                              textDecoration: 'none',
                          },
                      }
                    : {
                          '&:hover': {
                              textDecoration: 'underline',
                          },
                      }),
                ...sx,
            }}
        >
            {showIcon && (
                <ShuffleOutlinedIcon
                    sx={{
                        fontSize: '2rem',
                        width: '20px',
                        height: '20px',
                    }}
                />
            )}
            {t('Find replacement')}
        </Link>
    );
};
